import Cookie from 'js-cookie';

var blobToDataURL = function (blob) {
    var reader = new FileReader();
    return new Promise(function (resolve) {
        reader.onloadend = function () { return resolve(reader.result); };
        reader.readAsDataURL(blob);
    });
};

var hostname = window.location.hostname;
var domain = hostname.indexOf('.') > 0 ? hostname.split('.').slice(-2).join('.') : hostname;
var getCookie = function (name) {
    return Cookie.get(name);
};
var removeCookie = function (name) {
    Cookie.remove(name, { domain: domain });
};
var setCookie = function (name, value, options) {
    var _a = (options || {}).expires, expires = _a === void 0 ? 120000 : _a;
    Cookie.set(name, value, { domain: domain, expires: expires });
};

var createRandomId = function () {
    return (Math.random().toString(36).substring(2, 16) + Math.random().toString(36).substring(2, 16)).toUpperCase();
};

function Timer(callback, delay) {
    var timerId;
    var start = delay;
    var remaining = delay;
    this.clear = function () {
        clearTimeout(timerId);
    };
    this.pause = function () {
        clearTimeout(timerId);
        remaining -= Date.now() - start;
    };
    this.resume = function (newCallback) {
        start = Date.now();
        clearTimeout(timerId);
        timerId = setTimeout(newCallback || callback, remaining);
    };
    this.resume();
}

export { Timer as T, blobToDataURL as b, createRandomId as c, getCookie as g, removeCookie as r, setCookie as s };
//# sourceMappingURL=Timer-c078a2ef.js.map
